import { useEffect, useState } from "react";
import { constantCollections } from "../api/auth";

// Wraps GET /buyer/constantCollections — used to populate location type,
// product, consumption and delivery-timing dropdowns app-wide.
export default function useConstants() {
	const [constants, setConstants] = useState({
		locationTypes: [],
		locationProducts: [],
		locationConsumption: [],
		deliveryTiming: [],
	});
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		(async () => {
			const res = await constantCollections();
			if (res && !res.error && res.data?.constantCollection) {
				setConstants(res.data.constantCollection);
			}
			setLoading(false);
		})();
	}, []);

	return { constants, loading };
}
